export default "skymp5-front/55e830c323c1f7060dd333def45939b8.png";